import type { IconData } from '@stacksjs/iconify-core'

export const drop: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M515 206q45 45 69 103t26 118t-21 117t-67 103t-101 67t-116 23t-115-23t-102-67t-67-103T0 427t25-118t69-103L296 4q8-8 17 0z\"/>",
  "width": 610,
  "height": 840,
  "viewBox": "0 0 610 840"
}

export default drop
